import React from 'react'
import {useIntl, FormattedMessage} from 'react-intl'
import {Formik} from 'formik'
import * as Yup from 'yup'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import {Link as RouterLink} from 'react-router-dom'
import {makeStyles} from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import LoaderButton from 'components/atoms/LoaderButton'
import {passwordSchema} from 'lib/schemas'

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const ForgotPasswordConfirmationSchema = Yup.object().shape({
  confirmationCode: Yup.string().required('formValidations.required'),
  newPassword: passwordSchema,
})

export default function ForgotPasswordConfirmationForm({
  username,
  handleSubmit,
  isSubmitting,
}) {
  const classes = useStyles()
  const intl = useIntl()

  return (
    <Formik
      validationSchema={ForgotPasswordConfirmationSchema}
      initialValues={{username, confirmationCode: '', newPassword: ''}}
      onSubmit={handleSubmit}
    >
      {({values, errors, touched, handleChange, handleBlur, handleSubmit}) => (
        <form onSubmit={handleSubmit} className={classes.form} noValidate>
          <input
            value={values.username}
            name="username"
            hidden
            readOnly
            autoComplete="username"
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="confirmation-code"
            label={intl.formatMessage({id: 'confirmationCode'})}
            name="confirmationCode"
            autoFocus
            value={values.confirmationCode}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.confirmationCode && Boolean(errors.confirmationCode)}
            helperText={
              touched.confirmationCode &&
              errors.confirmationCode &&
              intl.formatMessage({id: errors.confirmationCode})
            }
          />
          <TextField
            type="password"
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="new-password"
            label={intl.formatMessage({id: 'newPassword'})}
            name="newPassword"
            autoComplete="new-password"
            value={values.newPassword}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.newPassword && Boolean(errors.newPassword)}
            helperText={
              touched.newPassword &&
              errors.newPassword &&
              intl.formatMessage({id: errors.newPassword})
            }
          />
          <LoaderButton
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            loadingText={intl.formatMessage({id: 'forgotPassword.submitting'})}
            isLoading={isSubmitting}
          >
            <FormattedMessage id="forgotPassword.confirmCode" />
          </LoaderButton>
          <Grid container>
            <Grid item xs>
              <Link to="/login" variant="body2" component={RouterLink}>
                <FormattedMessage id="forgotPassword.backToLogin" />
              </Link>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  )
}
